"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeoCleanURLCategories = exports.SearchPageNavigation = exports.LanguagePrefix = exports.SPVPagePrefix = exports.SearchPagePrefix = exports.PagePrefixTranslations = exports.PagePrefix = exports.SellPagePrefix = exports.Language = exports.LocalizationSettings = void 0;
exports.LocalizationSettings = {
    defaultLanguage: 'hy',
    appliedLanguage: ['hy', 'ru', 'en'],
    routerPrefix: '/:locale(ru|hy|en)?',
    defaultState: '?state=1',
    defaultAnnouncement: '/account/announcements/preview',
    defaultWishlist: '/account/wishlist/preview',
    blogLink: 'https://banali.am/blog/',
};
var Language;
(function (Language) {
    Language["hy"] = "hy";
    Language["ru"] = "ru";
    Language["en"] = "en";
})(Language = exports.Language || (exports.Language = {}));
exports.SellPagePrefix = {
    en: {
        sell: 'sell',
        rent: 'rent',
    },
    ru: {
        sell: 'prodazha',
        rent: 'arenda',
    },
    hy: {
        sell: 'vachark',
        rent: 'vardzakalutyun',
    },
};
exports.PagePrefix = {
    vachark: 'sell',
    vardzakalutyun: 'rent',
    arenda: 'rent',
    prodazha: 'sell',
    rent: 'rent',
    sell: 'sell',
};
exports.PagePrefixTranslations = {
    ru: {
        hy: {
            vachark: 'prodazha',
            vardzakalutyun: 'arenda',
            prodazha: 'vachark',
            arenda: 'vardzakalutyun',
        },
        en: {
            sell: 'prodazha',
            rent: 'arenda',
            prodazha: 'sell',
            arenda: 'rent',
        },
    },
    en: {
        hy: {
            vachark: 'sell',
            vardzakalutyun: 'rent',
            sell: 'vachark',
            rent: 'vardzakalutyun',
        },
        ru: {
            prodazha: 'sell',
            arenda: 'rent',
            sell: 'prodazha',
            rent: 'arenda',
        },
    },
    hy: {
        ru: {
            vachark: 'prodazha',
            vardzakalutyun: 'arenda',
            prodazha: 'vachark',
            arenda: 'vardzakalutyun',
        },
        en: {
            sell: 'vachark',
            rent: 'vardzakalutyun',
            vachark: 'sell',
            vardzakalutyun: 'rent',
        },
    },
};
exports.SearchPagePrefix = {
    ru: {
        prodazha: 'prodazha',
        arenda: 'arenda',
    },
    hy: {
        vachark: 'vachark',
        vardzakalutyun: 'vardzakalutyun',
    },
    en: {
        sell: 'sell',
        rent: 'rent',
    },
};
exports.SPVPagePrefix = {
    ru: ['prodazha', 'arenda'],
    hy: ['vachark', 'vardzakalutyun'],
    en: ['sell', 'rent'],
};
exports.LanguagePrefix = {
    en: {
        hy: 'hy/',
        ru: 'ru/',
    },
    hy: {
        en: 'en/',
        ru: 'ru/',
    },
    ru: {
        hy: 'hy/',
        en: 'en/',
    },
};
exports.SearchPageNavigation = {
    hy: {
        sell: '/ansharzh-guik-yerevanum',
        rent: '/ansharzh-guik-yerevanum',
    },
    ru: {
        sell: '/nedvizhimost-yerevan',
        rent: '/nedvizhimost-yerevan',
    },
    en: {
        sell: '/real-estate-yerevan',
        rent: '/real-estate-yerevan',
    },
};
exports.SeoCleanURLCategories = {
    realEstate: ['ansharzh-guik-', 'nedvizhimost-', 'real-estate-'],
    propertyTypes: {
        apartment: [
            'bnakaran-',
            'kvartira-',
            'kvartiri-',
            'apartments-',
            'apartment-',
        ],
        house: [
            'arandznatun-',
            'chastniy-dom-',
            'sepakan-tun-',
            'house-',
            'chastnie-doma-',
        ],
        commercial: [
            'komercion-tarack-',
            'grasenyakayin-taracq-',
            'kommercheskaya-',
            'commercial-',
        ],
    },
    newBuilding: [
        'norakaruyc-',
        'novostroiki-',
        'novostroika-',
        'v-novostroikax-',
        'norakaruic-',
        'v-novostroike-',
        'new-apartment-',
        'new-house-',
        'new-commercial-',
    ],
    fromDeveloper: ['karucapatoghic-', 'ot-zastroishika-', 'new-development-'],
    rooms: {
        '1': 'gte_1-lt_2',
        '2': 'gte_2-lt_3',
        '3': 'gte_3-lt_4',
        '4': 'gte_4',
    },
    apartmentDailyPrice: ['posutochno-', 'oravardzov-', 'daily-'],
};
